import React from 'react';

const ChartsIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="20"
    viewBox="0 0 24 20"
    {...props}
  >
    <defs>
      <filter id="83olsyq5ya">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 0 0.866667 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      filter="url(#83olsyq5ya)"
      transform="translate(-272 -171)"
    >
      <path
        fill="#000"
        fillRule="nonzero"
        d="M295 191h-22c-.552 0-1-.448-1-1s.448-1 1-1h22c.552 0 1 .448 1 1s-.448 1-1 1zm-1-3h-4c-.552 0-1-.448-1-1v-11c0-.552.448-1 1-1h4c.552 0 1 .448 1 1v11c0 .552-.448 1-1 1zm-8-17c.552 0 1 .448 1 1v15c0 .552-.448 1-1 1h-4c-.552 0-1-.448-1-1v-15c0-.552.448-1 1-1h4zm-8 8c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1h-4c-.552 0-1-.448-1-1v-7c0-.552.448-1 1-1h4z"
      />
    </g>
  </svg>
);

export default ChartsIcon;
